<script>
  import Donate from "$lib/components/Donate.svelte";
  import HTMLSnippet from "$lib/contentTypes/HTMLSnippet.svelte";
  import WordCloud from "$lib/contentTypes/WordCloud.svelte";

  export let data;
</script>

<div class="embedded-content">
  <Donate {...data.fields}>
    <slot name="title" slot="title">
      <WordCloud
        size={data.fields.variant === "buttons" ? "xlarge" : "medium"}
        data={data.fields.title}
      />
    </slot>
    <slot name="embed" slot="embed">
      <HTMLSnippet containerClassName="w-full flex justify-center" data={data.fields.htmlSnippet} />
    </slot>
  </Donate>
</div>
